import { useTranslation } from 'react-i18next'

import { Spinner } from '@vtex/shoreline'

import PageTitle from '~/components/PageTitle'

import CampaignsRedirectingHere from './CampaignsRedirectingHere'
import Installation from './Installation'
import ListAsDestinationRetailer from './ListAsDestinationRetailer'
import { useDestinationRetail } from './useDestinationRetail'

import './styles.module.css'
import { LoadingWrap, Page, PageHeading, SubText } from './styles'

const DestinationRetailConfigPage: React.FC = () => {
  const { t } = useTranslation()

  const {
    isPending,
    settingsError,
    campaignsPending,
    campaignsError,
    settings,
    campaigns,
    campaignPage,
    campaignsPerPage,
    changeCampaignPage,
    changeCampaignsPerPage,
    availableForNewCampaigns,
    toggleAvailability
  } = useDestinationRetail()

  return (
    <div data-destination-retail>
      <PageTitle title={t('rm:config.destinationRetail.pageTitle')} />

      <Page>
        <PageHeading>{t('rm:config.destinationRetail.pageTitle')}</PageHeading>
        <SubText>{t('rm:config.destinationRetail.subtitle')}</SubText>

        {isPending ? (
          <LoadingWrap>
            <Spinner />
          </LoadingWrap>
        ) : (
          <>
            <ListAsDestinationRetailer
              availableForNewCampaigns={availableForNewCampaigns}
              onToggleAvailability={toggleAvailability}
              error={settingsError}
            />

            <Installation
              scriptStatus={settings?.script_status}
              error={settingsError}
            />

            <CampaignsRedirectingHere
              isLoading={campaignsPending}
              rows={campaigns.data}
              total={campaigns.total}
              currentPage={campaignPage}
              itemsPerPage={campaignsPerPage}
              onPageChange={changeCampaignPage}
              onItemsPerPageChange={changeCampaignsPerPage}
              error={campaignsError}
            />
          </>
        )}
      </Page>
    </div>
  )
}

export default DestinationRetailConfigPage
